import React, { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { PageProps } from "../types/auth";

import styles from './styles/CreateOrganizationPage.module.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const CreateOrganizationPage: React.FC<PageProps> = ({ token, selectedOrgID }) => {
  const [name, setName] = useState<string>("");
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      const response = await fetch(`${API_BASE_URL}/api/organizations`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Org-ID": selectedOrgID?.toString() || "",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.error || "Failed to create organization.");
        return;
      }

      // Navigate back to organizations page
      navigate("/organizations");
    } catch (err) {
      setError("An unexpected error occurred.");
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Create Organization</h1>
      {error && <p className={styles.errorMessage}>{error}</p>}
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.formGroup}>
          <label className={styles.label}>Organization Name:</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className={styles.input}
          />
        </div>
        <button type="submit" className={styles.submitButton}>Submit</button>
      </form>
    </div>
  );
};

export default CreateOrganizationPage; 
